<ion-header class="ion-no-border">
  <ion-toolbar color="primary">
    <ion-title>{{business?.name}}</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/tecservice/home/businesses"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div id="wrapper" class="ion-padding" *ngIf="business">
    <swiper-container #swiper [pagination]="true" *ngIf="business.images" id="ads">
      <swiper-slide *ngFor="let image of business.images; let i = index">
        <ion-img [src]="image.src" (click)="viewImage(image.src, '', '')"></ion-img>
      </swiper-slide>
    </swiper-container>

    <ion-toolbar *ngIf="business.reward_active || borrego&&business.menus">
      <ion-segment mode="md" [(ngModel)]="show">
        <ion-segment-button mode="md" value="info">
          <ion-label>INFO</ion-label>
        </ion-segment-button>
        <ion-segment-button mode="md" value="rewards" *ngIf="business.reward_active">
          <ion-label>RECOMPENSAS</ion-label>
        </ion-segment-button>
        <ion-segment-button mode="md" value="menu" *ngIf="borrego&&business.menus">
          <ion-label>MENÚ</ion-label>
        </ion-segment-button>
      </ion-segment>
    </ion-toolbar>

    <div class="segment-content-container info" *ngIf="show=='info'">
      <ion-toolbar class="inner-toolbar">
        <ion-segment mode="md" [(ngModel)]="info">
          <ion-segment-button mode="md" value="about">
            <ion-label>ACERCA DE</ion-label>
          </ion-segment-button>
          <ion-segment-button mode="md" value="reviews">
            <ion-label>RESEÑAS</ion-label>
          </ion-segment-button>
        </ion-segment>
      </ion-toolbar>
      <div *ngIf="info=='about'" class="about">
        <ion-item lines="none">
          <ion-thumbnail slot="start">
            <img [src]="business.logo" />
          </ion-thumbnail>
          <ion-label class="ion-text-wrap">
            <h2>{{business.name}}</h2>
            <p>{{business.description}}</p>
          </ion-label>
        </ion-item>
        <div class="divider"></div>
        <ion-grid>
          <ion-row>
            <ion-col>
              <label>
                <ion-icon src="/assets/icon/clock.svg" color="primary"></ion-icon>
                Horario
              </label>
              <p>{{business.horary}}</p>
            </ion-col>
            <ion-col>
              <label>
                <ion-icon src="/assets/icon/delivery.svg" color="primary"></ion-icon>
                Envío
              </label>
              <p [hidden]="business.home_delivery!=1">
                <ion-icon class="block" name="checkmark-circle-outline" color="primary"></ion-icon>
                Sí
              </p>
              <p [hidden]="business.home_delivery&&business.home_delivery!=0">
                <ion-icon class="block" name="close-circle" color="primary"></ion-icon>
                No
              </p>
              <p [hidden]="business.home_delivery!=2">
                <ion-icon class="block" name="remove-circle" color="primary"></ion-icon>
                Sí, restringido
              </p>
            </ion-col>
            <ion-col tappable (click)="goLocation()">
              <label>
                <ion-icon src="/assets/icon/location-pin.svg" color="primary"></ion-icon>
                Ubicación
              </label>
              <p>{{business.location_name}}</p>
            </ion-col>
          </ion-row>
        </ion-grid>
        <div class="divider"></div>
        <div id="event_description">
          <label>Contacto</label>
          <ion-grid>
            <ion-row>
              <ion-col>
                <img
                  src="assets/imgs/botones/contacto/phone.svg"
                  [class.unavailable]="!business.phone1"
                  (click)="goPhone()"
                />
              </ion-col>
              <ion-col>
                <img
                  src="assets/imgs/botones/contacto/whatsapp.svg"
                  [class.unavailable]="!business.whatsapp"
                  (click)="goWhatsapp()"
                />
              </ion-col>
              <ion-col hidden>
                <img
                  src="assets/imgs/botones/contacto/map.svg"
                  [class.unavailable]="!business.lat"
                  (click)="goLocation()"
                />
              </ion-col>
              <ion-col>
                <img
                  src="assets/imgs/botones/contacto/email.svg"
                  [class.unavailable]="!business.email"
                  (click)="goMail()"
                />
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <img
                  src="assets/imgs/botones/contacto/facebook.svg"
                  [class.unavailable]="!business.facebook"
                  (click)="goFacebook()"
                />
              </ion-col>
              <ion-col>
                <img
                  src="assets/imgs/botones/contacto/instagram.svg"
                  [class.unavailable]="!business.instagram"
                  (click)="goInstagram()"
                />
              </ion-col>
              <ion-col>
                <img
                  src="/assets/imgs/botones/contacto/web.svg"
                  [class.unavailable]="!business.web"
                  (click)="goWeb()"
                />
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
      </div>
      <div *ngIf="info=='reviews'" class="reviews">
        <div class="own-comment" *ngIf="!business.review">
          <ion-button shape="block" fill="outline" color="primary" (click)="goReview()">
            <ion-label style="margin-left: 5px">Calificar</ion-label>
          </ion-button>
        </div>
        <div class="own-comment" *ngIf="business.review">
          <h4>
            Mi calificación:
            <span style="font-weight: bold">{{business.review.answer1}}</span>
            <ion-icon name="star" color="primary"></ion-icon>
            <ion-button shape="round" fill="outline" color="primary" size="small" (click)="goReview()">
              Cambiar
            </ion-button>
          </h4>
          <ion-label>Mi comentario</ion-label>
          <p>{{business.review.comments}}</p>
        </div>
        <div class="divider"></div>
        <div class="reviews" *ngIf="business.reviews_count">
          <ion-grid>
            <ion-row class="rating">
              <ion-col>
                <h1 class="rating-num">{{business.reviews_overall}}</h1>
              </ion-col>
              <ion-col>
                <div>
                  <ion-icon name="star"></ion-icon>
                  <ion-icon
                    [name]="'md-star'+(business.reviews_overall>1.4&&business.reviews_overall<=1.6?'-half':(business.reviews_overall>1.6?'':'-outline'))"
                  ></ion-icon>
                  <ion-icon
                    [name]="'md-star'+(business.reviews_overall>2.4&&business.reviews_overall<=2.6?'-half':(business.reviews_overall>2.6?'':'-outline'))"
                  ></ion-icon>
                  <ion-icon
                    [name]="'md-star'+(business.reviews_overall>3.4&&business.reviews_overall<=3.6?'-half':(business.reviews_overall>3.6?'':'-outline'))"
                  ></ion-icon>
                  <ion-icon
                    [name]="'md-star'+(business.reviews_overall>4.4&&business.reviews_overall<=4.6?'-half':(business.reviews_overall>4.6?'':'-outline'))"
                  ></ion-icon>
                </div>
                <ion-icon name="person"></ion-icon>
                {{business?.reviews_count}} total
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="4">
                5
                <ion-icon name="star"></ion-icon>
                <ion-icon name="star"></ion-icon>
                <ion-icon name="star"></ion-icon>
                <ion-icon name="star"></ion-icon>
                <ion-icon name="star"></ion-icon>
              </ion-col>
              <ion-col size="8">
                <div class="progress">
                  <div
                    class="progress-bar"
                    [style.width]="(100*business.reviews_five/business.reviews_count)+'%'"
                  ></div>
                </div>
              </ion-col>
              <!-- end 5 -->
            </ion-row>
            <ion-row>
              <ion-col size="4">
                4
                <ion-icon name="star"></ion-icon>
                <ion-icon name="star"></ion-icon>
                <ion-icon name="star"></ion-icon>
                <ion-icon name="star"></ion-icon>
              </ion-col>
              <ion-col size="8">
                <div class="progress">
                  <div
                    class="progress-bar"
                    [style.width]="(100*business.reviews_four/business.reviews_count)+'%'"
                  ></div>
                </div>
              </ion-col>
              <!-- end 4 -->
            </ion-row>
            <ion-row>
              <ion-col size="4">
                3
                <ion-icon name="star"></ion-icon>
                <ion-icon name="star"></ion-icon>
                <ion-icon name="star"></ion-icon>
              </ion-col>
              <ion-col size="8">
                <div class="progress">
                  <div
                    class="progress-bar"
                    [style.width]="(100*business.reviews_three/business.reviews_count)+'%'"
                  ></div>
                </div>
              </ion-col>
              <!-- end 3 -->
            </ion-row>
            <ion-row>
              <ion-col size="4">
                2
                <ion-icon name="star"></ion-icon>
                <ion-icon name="star"></ion-icon>
              </ion-col>
              <ion-col size="8">
                <div class="progress">
                  <div class="progress-bar" [style.width]="(100*business.reviews_two/business.reviews_count)+'%'"></div>
                </div>
              </ion-col>
              <!-- end 2 -->
            </ion-row>
            <ion-row>
              <ion-col size="4">
                1
                <ion-icon name="star"></ion-icon>
              </ion-col>
              <ion-col size="8">
                <div class="progress">
                  <div class="progress-bar" [style.width]="(100*business.reviews_one/business.reviews_count)+'%'"></div>
                </div>
              </ion-col>
              <!-- end 1 -->
            </ion-row>
            <!-- end row -->
          </ion-grid>
          <div class="reviews-panel" #myReviews>
            <div class="review" *ngFor="let review of reviews; let i = index" [hidden]="review.comments==''">
              <ion-grid>
                <ion-row>
                  <ion-col size="9">
                    <h3>{{review.name}}</h3>
                    <div class="likes-container">
                      <span>{{review.updated_at | timeAgo : true}}</span>
                      <span [hidden]="likesHidden">
                        &nbsp;&nbsp;&nbsp;
                        <ion-icon src="/assets/icon/like.svg"></ion-icon>
                        {{review.like}} &nbsp;&nbsp;&nbsp;
                        <ion-icon src="/assets/icon/dislike.svg"></ion-icon>
                        {{review.dislike}}
                      </span>
                    </div>
                  </ion-col>
                  <ion-col>
                    <ion-icon name="star"></ion-icon>
                    {{review.answer1}}
                  </ion-col>
                </ion-row>
                <ion-row>
                  <div class="icons-container" [hidden]="likesHidden">
                    <ion-icon
                      src="/assets/icon/like.svg"
                      class="like"
                      (click)="updateLikes(review, i, 0)"
                      [hidden]="!review.like_status||review.like_status<1"
                    ></ion-icon>
                    <ion-icon
                      src="/assets/icon/like.svg"
                      class="unlike"
                      (click)="updateLikes(review, i, 1)"
                      [hidden]="review.like_status==1"
                    ></ion-icon>
                    <ion-icon
                      src="/assets/icon/dislike.svg"
                      class="like"
                      (click)="updateLikes(review, i, 0)"
                      [hidden]="!review.like_status||review.like_status>-1"
                    ></ion-icon>
                    <ion-icon
                      src="/assets/icon/dislike.svg"
                      class="unlike"
                      (click)="updateLikes(review, i, -1)"
                      [hidden]="review.like_status==-1"
                    ></ion-icon>
                  </div>
                  <p class="comments">{{review.comments}}</p>
                </ion-row>
              </ion-grid>
            </div>
          </div>
          <ion-infinite-scroll (ionInfinite)="doInfiniteReviews($event)">
            <ion-infinite-scroll-content
              loadingSpinner="bubbles"
              loadingText="Cargando comentarios..."
            ></ion-infinite-scroll-content>
          </ion-infinite-scroll>
          <div *ngIf="!pagingEnabled" id="pagingEnabled">No hay más comentarios.</div>
        </div>
      </div>
    </div>

    <div class="segment-content-container rewards" *ngIf="show=='rewards'">
      <ion-button shape="block" color="primary" icon-start class="bluetext" (click)="scan()">
        <ion-icon src="/assets/icon/coin.svg"></ion-icon>
        <ion-label style="margin-left: 5px">Acumular</ion-label>
      </ion-button>
      <ion-row>
        <ion-col>
          <p>Puntos acumulados:</p>
        </ion-col>
        <ion-col>
          <p class="user_points">
            {{business.user_points}}
            <ion-icon src="/assets/icon/coin.svg" color="primary"></ion-icon>
          </p>
        </ion-col>
      </ion-row>
      <div class="divider"></div>
      <div
        class="reward-container"
        *ngFor="let reward of business.rewards"
        [class.unavailable]="business.user_points<reward.points_needed"
        (click)="business.user_points>=reward.points_needed && scan(reward)"
      >
        <div class="reward-content">
          <h2>{{reward.reward}}</h2>
        </div>
        <div class="reward-divider"></div>
        <div class="reward-value">
          Canjear
          <br />
          <span>
            {{reward.points_needed}}
            <ion-icon src="/assets/icon/coin.svg" color="primary"></ion-icon>
          </span>
        </div>
      </div>
    </div>

    <div class="segment-content-container" *ngIf="show=='menu'">
      <h3>Menú {{business.name}}</h3>
      <div class="divider"></div>
      <div class="mealplans">
        <ion-grid>
          <ion-row>
            <ion-col *ngFor="let mealplan of business.menus; let i = index" class="mealplan">
              <ion-fab-button
                color="light"
                [class.used]="mealplan.used"
                (click)="viewImage(mealplan.url, mealplan.title,'')"
              >
                <ion-icon src="/assets/icon/icono-cena.svg" *ngIf="i==2"></ion-icon>
                <ion-icon src="/assets/icon/icono-comida.svg" *ngIf="i==1"></ion-icon>
                <ion-icon src="/assets/icon/icono-desayuno.svg" *ngIf="i==0"></ion-icon>
              </ion-fab-button>
              <div *ngIf="i==0">Desayuno</div>
              <div *ngIf="i==1">Comida</div>
              <div *ngIf="i==2">Cena</div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </div>
  </div>
</ion-content>
